import React, { useState, useEffect } from "react";
import "./homepage.css";
import Header from "./header";
import { API_BASE } from "../../apiConfig";
import slide1 from "./CSE_DEPT_FRONT.jpg";
import slide2 from "./csrl.jpeg";
import slide3 from "./csrl2.jpeg";
import slide4 from "./csrl_iot1.jpeg";
import slide5 from "./csrl_iot2.jpeg";
import Footer from "./footer";

function Slideshow() {
  const staticImages = [slide1, slide2, slide3, slide4, slide5];
  const [images, setImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    fetch(`${API_BASE}/slideshow`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        if (data && data.length > 0) {
          setImages(data.map(item => item.imageUrl));
        } else {
          setImages(staticImages);
        }
      })
      .catch(() => {
        setImages(staticImages);
      });
  }, []);

  useEffect(() => {
    if (images.length === 0) return;
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  if (images.length === 0) {
    return <div className="slideshow-container"><div className="slide">Loading slideshow...</div></div>;
  }

  return (
    <div className="slideshow-container">
      <img
        src={images[currentSlide]}
        alt={`Slide ${currentSlide + 1}`}
        className="slide"
      />
      <a
        className="prev"
        onClick={() =>
          setCurrentSlide((currentSlide - 1 + images.length) % images.length)
        }
      >
        &#10094;
      </a>
      <a
        className="next"
        onClick={() => setCurrentSlide((currentSlide + 1) % images.length)}
      >
        &#10095;
      </a>
      <div className="dots-container">
        {images.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${currentSlide === idx ? "active" : ""}`}
            onClick={() => setCurrentSlide(idx)}
          ></span>
        ))}
      </div>
    </div>
  );
}

function WriteUp() {
  return (
    <div className="write-up">
      <h2>Welcome to Cyber Security Research Lab</h2>
      <p>
        At the forefront of securing digital ecosystems, the Cyber Security
        Research Lab at NITK is dedicated to innovation, research, and knowledge
        in cyber security. We tackle challenges in areas like network security,
        blockchain, IoT, 5G security, and digital forensics, leveraging
        cutting-edge technology and collaborative expertise. With a focus on
        academic excellence and real-world impact, our lab serves as a platform
        for developing robust solutions to evolving cyber threats, fostering
        talent, and driving advancements in a rapidly changing digital
        landscape.
      </p>
    </div>
  );
}

function AnnouncementBoard() {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/announcements`)
      .then((response) => {
        if (!response.ok) throw new Error();
        return response.json();
      })
      .then((data) => setAnnouncements(data))
      .catch((error) => {
        console.log("Failed fetching dynamic announcements, falling back to static:", error);
        fetch("/announcements.json")
          .then((response) => response.json())
          .then((data) => setAnnouncements(data))
          .catch((err) => console.error("Error fetching fallback announcements:", err));
      });
  }, []);

  return (
    <div className="announcement-board">
      <h3>Announcements</h3>
      <div className="announcement-list">
        {announcements.map((item, index) => (
          <div className="announcement-card" key={index}>
            <div className="announcement-left">
              <div className="arrow-icon">»</div>
              <div className="vertical-line" />
            </div>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="announcement-text"
            >
              {item.text}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

function HomePage() {
  const [importantUpdates, setImportantUpdates] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/updates`)
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => setImportantUpdates(data))
      .catch((err) => {
        console.log("Failed loading dynamic updates, falling back to static:", err);
        fetch("/updates.json")
          .then((res) => res.json())
          .then((data) => setImportantUpdates(data))
          .catch((e) => console.error("Failed to load fallback updates:", e));
      });
  }, []);

  return (
    <div>
      <Header />

      {/* ✅ Dynamic Marquee for Multiple Updates */}
      <div className="important-update-container">
        <div className="important-label">Important Update :</div>
        <div className="custom-marquee">
          <div className="marquee-track">
            {importantUpdates.map((item, index) => (
              <span key={index} className="marquee-item">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="marquee-link"
                >
                  {item.text}
                </a>
                <span className="separator">|</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="content-container">
          <Slideshow />
          <WriteUp />
        </div>
        <AnnouncementBoard />
      </div>

      <Footer />
    </div>
  );
}

export default HomePage;
